import jwtDecode from "jwt-decode";
import { formatMoney, formatNumberToDecimal, numberWithCommas } from "./FormattingHelper";
import { BiCheckboxChecked, BiCheckbox } from "react-icons/bi";

const MODAL_FADE_OUT = 280;

// Dates

export const getTodayDate = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  return mm + "-" + dd + "-" + yyyy;
};

export const getInputDate = (date) => {
  if (date === undefined || date === null) return "";
  else return date.toISOString().split("T")[0];
};

export const isDateGreaterThanCurrentDate = (dateStr) => {
  const date = new Date(dateStr);
  return date > new Date();
};

// modals
export const initModal = (id, setShowModal) => {
  const closeModalEvent = function (event) {
    if (!event.target.closest(id)) {
      document.getElementById(id.substring(1)).classList.add("fadeOut");
      setTimeout(() => {
        setShowModal();
      }, MODAL_FADE_OUT); // A little less then the time of the fade out animation for smooth transition
    }
  };

  document.addEventListener("click", closeModalEvent, true);
  return closeModalEvent;
};

export const initFooterBtns = (footerId, BtnIds) => {
  const modalFooter = document.getElementById(footerId);
  for (let i = 0; i < BtnIds.length; i++) {
    const btn = document.getElementById(BtnIds[i]);
    if (btn !== null) {
      btn.style.display = "block";
      modalFooter.insertAdjacentElement("afterbegin", btn);
    } else {
      console.log("button not found");
    }
  }
};

// web
export const getCookie = (cookieName) => {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};

export const getParamFromURL = (param) => {
  let url = window.location.href;
  let urlParams = url.split("?");
  if (urlParams.length < 2) return null;
  else url = urlParams[1]; //get rid of "?" in querystring

  let qArray = url.split("&"); //get key-value pairs
  for (let i = 0; i < qArray.length; i++) {
    let pArr = qArray[i].split("="); //split key and value
    if (pArr[0] === param) return pArr[1]; //return value
  }
};

export const isJWTTokenValid = () => {
  try {
    const tokenExpirationDate = JSON.parse(JSON.stringify(jwtDecode(getItemFromStorage("jwtToken")))).exp;
    return Date.now() < tokenExpirationDate * 1000;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const getItemFromStorage = (key) => {
  if (window.sessionStorage.getItem(key) !== null) return sessionStorage.getItem(key);
  else if (window.localStorage.getItem(key) !== null) return localStorage.getItem(key);
  else return null;
};

export const setItemInStorage = (key, value) => {
  window.sessionStorage.setItem(key, value);
  window.localStorage.setItem(key, value);
};

export const clearItemFromStorage = (key) => {
  window.sessionStorage.removeItem(key);
  window.localStorage.removeItem(key);
};

export const clearStorage = () => {
  window.sessionStorage.clear();
  window.localStorage.clear();
};

// table cells formatting functions
export const formatMoneyTableCell = (cellValue, rowData) => {
  if (cellValue === undefined || cellValue === null) return <div>{formatMoney(0)}</div>;
  return <div>{formatMoney(cellValue)}</div>;
};

export const formatMoneyTo6DecimalTableCell = (cellValue, rowData) => {
  if (cellValue === undefined || cellValue === null) return <div></div>;
  return <div>{formatMoney(cellValue, 6)}</div>;
};

export const formatMBTableCell = (cellValue, rowData) => {
  if (cellValue === undefined || cellValue === null) return <div>{formatNumberToDecimal(0, 2)}</div>;
  return <div>{formatNumberToDecimal(cellValue, 2)}</div>;
};

export const formatMBNoDecimalsTableCell = (cellValue, rowData) => {
  if (cellValue === undefined || cellValue === null) return <div>0</div>;
  return <div>{numberWithCommas(cellValue) + " MB"}</div>;
};

export const formatCheckboxTableCell = (cellValue, rowData) => {
  if (cellValue === undefined || cellValue === null)
    return (
      <div>
        <BiCheckbox size={25} />
      </div>
    );
  return <div>{cellValue == 1 ? <BiCheckboxChecked size={25} /> : <BiCheckbox size={25} />}</div>;
};

export const formatNumberWithPercentSign = (cellValue, rowData) => {
  if (cellValue === undefined || cellValue === null) return <div>{cellValue}</div>;
  return <div>{formatNumberToDecimal(cellValue, 2) + " %"}</div>;
};

// forms
export const handleDxRadioSelection = (parentId, btnId) => {
  const parentBtns = document.getElementById(parentId).getElementsByTagName("button");
  for (let i = 0; i < parentBtns.length; i++) {
    const btn = parentBtns[i];
    if (btn.id === btnId) {
      document.getElementById(btnId).classList.add("dx-radio-btn-active");
    } else {
      document.getElementById(btn.id).classList.remove("dx-radio-btn-active");
    }
  }
};

export const getDefaultVal = (val, defaultVal) => {
  if (val === undefined || val === null) return defaultVal;
  else return val;
};

// general
export const handleTabSwitch = (tabsArray, tabName) => {
  tabsArray.forEach((tab) => {
    if (tab[0] !== tabName && tab[1] === true) {
      tab[2](false);
    }
    if (tab[0] === tabName) {
      tab[2](true);
    }
  });
};

export const navbarInit = function (parentId) {
  let btnContainer = document.getElementById(parentId);
  let btns = btnContainer.getElementsByClassName("stats-navbar-item");
  for (let i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function () {
      let current = btnContainer.getElementsByClassName("stats-navbar-item navbar-item-active");
      current[0].className = current[0].className.replace(" navbar-item-active", "");
      this.className += " navbar-item-active";
    });
  }
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const setDarkMode = () => {
  let theme = getItemFromStorage("theme") || "light";
  if (theme === "dark") document.getElementById("App").classList.add("dark");
  else document.getElementById("App").classList.remove("dark");
};

// Toast notifications

export const handleToastPromiseError = (err, errDescription) => {
  let errorMsg = err.response === undefined ? err.message : err.response.data.description;
  return `${(errDescription !== undefined ? errDescription : "Error Occurred:") + "\n" + errorMsg}`;
};

export const generateUniqueRandomId = () => {
  return "_" + Math.random().toString(36).substring(2, 9);
};
